import React from "react";

function Bangalore(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M3.25269 13.8994H20.472V19.4461H3.25269V13.8994Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M7.07861 12.6292H8.82672V19.4463H7.07861V12.6292Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M7.95312 11.4119V12.6289"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M15.2095 12.6292H16.9576V19.4463H15.2095V12.6292Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M16.084 11.4119V12.6289"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M20.4946 12.6292H22.7382V19.4463H20.4946V12.6292Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path d="M21.6174 11.4119V12.6289V11.4119Z" fill="white" />
      <path
        d="M21.6174 11.4119V12.6289"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M8.81934 11.6025H15.2096V19.4207H8.81934V11.6025Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M9.90186 9.53931H14.1273V11.605H9.90186V9.53931Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M9.10864 7.60059H14.9221V9.53926H9.10864V7.60059Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M14.3386 7.60065C14.5801 7.29615 14.7011 6.91346 14.6786 6.52549C14.6561 6.13752 14.4917 5.77138 14.2167 5.49682L13.1317 4.41696C12.9845 4.26953 12.8096 4.15257 12.6171 4.07278C12.4246 3.99298 12.2183 3.9519 12.0099 3.9519C11.8016 3.9519 11.5952 3.99298 11.4027 4.07278C11.2103 4.15257 11.0354 4.26953 10.8881 4.41696L9.81336 5.49682C9.53883 5.77166 9.37475 6.13773 9.35227 6.52554C9.32979 6.91335 9.45046 7.29592 9.69139 7.60065H14.3386Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M10.9912 14.8804H13.0341V19.4082H10.9912V14.8804Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M3.22632 15.7314H6.87498"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M3.22632 17.4592H6.87498"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M16.8967 15.7314H20.5454"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M16.8967 17.4592H20.5454"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path
        d="M0.980713 12.6292H3.22429V19.4463H0.980713V12.6292Z"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
      <path d="M2.10352 11.4119V12.6289V11.4119Z" fill="white" />
      <path
        d="M2.10352 11.4119V12.6289"
        stroke="#17142A"
        strokeWidth="0.337966"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoBangalore = React.memo(Bangalore);
export default MemoBangalore;
